module.exports = __webpack_public_path__ + "img/Алматы облысы.9a0e7dad.png";